import Cookies from 'universal-cookie';
import { LANG, LangType } from 'common/constants';
import { CookiesStore } from 'reducers';

export const UTM_LABELS_COOKIE = 'utm_labels';

export const RM_SESSION_COOKIE = 'rm_session';

export const LOYALITY_TYPE_PRO = 'loyaltyTypePRO';

export type CookiesData = string | CookiesStore['cookies'] | null;

export const createCookies = (data: CookiesData) => new Cookies(data);

export const getQaCookies = (cookie: string): string => {
  if (typeof cookie === 'string') {
    return cookie
      .split('; ')
      .filter((value) => value.includes('testId'))
      .join('; ');
  }

  return '';
};

export const getLangFromCookies = (cookies: Cookies): LangType => {
  const cookieLang = cookies?.get('lang')?.toLowerCase() ?? 'ru';

  return LANG[cookieLang] ? cookieLang : 'ru';
};

export const getRMSessionCookie = (cookie: string): string => {
  if (typeof cookie !== 'string') return '';

  return (
    cookie
      .split('; ')
      .find((row) => row.startsWith(`${RM_SESSION_COOKIE}=`))
      ?.split('=')[1] || ''
  );
};

export const getLoyalityProCookie = (cookie: string): string => {
  if (typeof cookie !== 'string') return '';

  return (
    cookie
      .split('; ')
      .find((row) => row.startsWith(`${LOYALITY_TYPE_PRO}=`))
      ?.split('=')[1] ?? ''
  );
};
